import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Select, Store} from '@ngxs/store';
import {AppState} from '../../state/appState';
import {first, mergeMap, take} from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  @Select(AppState.auth$) authString$: Observable<string>;

  constructor(private store: Store) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.authString$.pipe(
      take(1),
      mergeMap((authString) => {
        request = request.clone({
          setHeaders: {
            Authorization: `Basic ${authString}`
          }
        });

        return next.handle(request);
      })
    );
  }
}
